import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import {getMessagemErro} from "../../utils/erro";
import {formataData} from '../../utils/formatadorData';
import api from "../../services/api";
import './Contract.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faMagnifyingGlass, faMagnifyingGlassPlus, faPowerOff, faSearchDollar } from "@fortawesome/free-solid-svg-icons";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

export const ContractList =

// router
withRouter(
// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {
	
		constructor(props){
			super(props);
			this.initialState = {
				criterioPesquisa: {
					idTipoContrato: '',
					nomeContrato: '',
					nomeItemFaturavel: '',
					ativos : true,
					contratoSerpro: true,
				},
				tiposContratos: [],
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				exibeModalAtivar: false,
				exibeModalInativar: false,
				botoesHabilitados : true,
		 	};

			 this.state = this.initialState;

			this.handleInputChange = this.handleInputChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.fechaModais = this.fechaModais.bind(this);
			this.handleOkModais = this.handleOkModais.bind(this);
			this.isEdicaoPermitida = this.isEdicaoPermitida.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					
					<div style={{margin: "10px"}}>
						<h1>Contratos</h1>
					</div>
					
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();

			const user = this.props.user;
			if(user.isAdministrador === true){
				const criterioPesquisa = this.state.criterioPesquisa;
				criterioPesquisa['contratoSerpro'] = false;
				this.setState(prevState => ({ ...prevState, criterioPesquisa,})) 
			}

			api.get('/api/contrato/tipos')
				.then(response => { 
					this.setState(prevState => ({ ...prevState, tiposContratos: response.data, })) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os tipos de contrato " + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento da página")
				});

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { criterioPesquisa, resultadoPesquisa, pesquisaExecutada } = this.state;
			const { idTipoContrato, nomeContrato, nomeItemFaturavel, ativos, contratoSerpro } = criterioPesquisa;
			const { content } = resultadoPesquisa;

			return(
				<div className="container-fluid">

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalAtivar}
						handleOk={() => this.handleOkModais()}
						handleCancel={() => this.fechaModais()}
						message="Deseja realmente habilitar o contrato?"/>

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalInativar}
						handleOk={() => this.handleOkModais()}
						handleCancel={() => this.fechaModais()}
						message="Deseja realmente desabilitar o contrato?"/>

					<div className="br-form">
						<div className="row">
							<div className="col-md-3">
								<div className="field">
									<div className="input">
										<label htmlFor="consumidora">Mostrar:</label>
										<SelectSearch
											id="contratoSerpro"
											name="contratoSerpro"
											options={[{ value: true, label: 'Contratos do Serpro' }, { value: false, label: 'Contratos não Serpro' }]}
											includeAllOption={true}
											onChange={this.handleInputChange}
											value={contratoSerpro}
										/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="idTipoContrato">Tipo de Contrato:</label>
										{ this.state.tiposContratos.length > 0 && 
											<SelectSearch
												id="idTipoContrato" //erro limpar
												name="idTipoContrato"
												includeAllOption={true}
												options={this.state.tiposContratos.map(tipoContrato => ({ value: tipoContrato.codigo, label: tipoContrato.nome }))}
												onChange={this.handleInputChange}
												value={idTipoContrato}
											/>
										}
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="nomeContrato">Nome:</label>
										<input type="text" id="nomeContrato" name="nomeContrato" 
											value={nomeContrato}  
											onChange={this.handleInputChange} 
											maxLength="100"/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="nomeItemFaturavel">Item Faturável:</label>
										<input type="text" id="nomeItemFaturavel" name="nomeItemFaturavel" 
											value={nomeItemFaturavel}  
											onChange={this.handleInputChange} 
											maxLength="255"/>
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="ativos">Selecionar:</label>
										<SelectSearch
											id="ativos"
											name="ativos"
											includeAllOption={true}
											options={[{ value: true, label: 'Ativos' }, { value: false, label: 'Inativos' }]}
											onChange={this.handleInputChange}
											value={ativos}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<Link to="/contract/new"> 
									<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Novo</button>
								</Link>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>
					
						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col" style={{width: "5%"}}>Contrato Serpro</th>
											<th scope="col">Tipo de Contrato</th>
											<th scope="col">Nome</th>
											<th scope="col">Item Faturável</th>
											<th scope="col">Situação</th>
											<th scope="col">Início Vigência</th>
											<th scope="col">Fim Vigência</th>
											<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((contrato, index) => {
												const edicaoPermitida = this.isEdicaoPermitida(contrato);
												return (
 
													<tr key={index} >
														<td>{contrato.contratoSerpro ? 'Sim' : 'Não'}</td>
														<td>{contrato.nomeTipoContrato}</td>
														<td>{contrato.nomeContrato}</td>
														<td>{contrato.nomeItemFaturavel}</td>
														<td>
															{contrato.ativo === true ? 'Ativo' : 'Inativo'}
														</td>
														<td>{formataData(contrato.inicioVigencia)}</td>
														<td>{formataData(contrato.fimVigencia)}</td>
														<td className="text-center">
															<div className="actions">
																{ (contrato.ativo === true) &&
																	<>
																		<Link to={`/contract/${edicaoPermitida ? 'edit' : 'view'}/${contrato.id}`}>
																			<button type="button" disabled={!this.state.botoesHabilitados} title={`${edicaoPermitida ? 'Editar' : 'Visualizar'} o contrato`}>
																				<span className="sr-only">`${edicaoPermitida ? 'Editar' : 'Visualizar'}</span>
																				<FontAwesomeIcon icon={edicaoPermitida ? faEdit : faMagnifyingGlass} style={{color: "#1351b4"}} />
																			</button>
																		</Link>

																		<Link to={`/contract/billing-reference-list/${contrato.id}`}>
																			<button type="button" disabled={!this.state.botoesHabilitados} title={`${edicaoPermitida ? 'Editar' : 'Visualizar'} as referências de faturamento do contrato`}>
																				<span className="sr-only">`${edicaoPermitida ? 'Editar' : 'Visualizar'}</span>
																				<FontAwesomeIcon icon={faMagnifyingGlassPlus} style={{color: "#1351b4"}} />
																			</button>
																		</Link>
																	</>
																}

																{ (contrato.ativo === true && contrato.idTipoContrato === 'A') &&
																	<Link to={`/contract/api-contract-details-${edicaoPermitida ? 'edit' : 'view'}/${contrato.id}`}>
																		<button type="button" disabled={!this.state.botoesHabilitados}  title={`${edicaoPermitida ? 'Editar' : 'Visualizar'} as informações de faturamento das API's do contrato`}>
																			<span className="sr-only">Informações de faturamento das API's do contrato</span>
																			<FontAwesomeIcon icon={faSearchDollar} style={{color: "#1351b4"}}/>
																		</button>
																	</Link>
																}

																{ edicaoPermitida && contrato.ativo === false &&
																	<button type="button" disabled="true" title="Editar o contrato">
																		<span className="sr-only">Editar</span>
																		<FontAwesomeIcon icon={faEdit} style={{color: "#1351b4"}} />
																	</button>
																}

																{ edicaoPermitida && contrato.ativo === true &&
																	<button type="button" onClick={() => this.confirmaOperacao(contrato)} disabled={!this.state.botoesHabilitados}  title="Desabilitar o contrato">
																		<span className="sr-only">Desativar</span>
																		<FontAwesomeIcon icon={faPowerOff} id="on" />
																	</button>
																}
																
																{ edicaoPermitida && contrato.ativo === false &&
																	<button type="button" onClick={() => this.confirmaOperacao(contrato)} disabled={!this.state.botoesHabilitados} title="Habilitar o contrato">
																		<span className="sr-only">Ativar</span>
																		<FontAwesomeIcon icon={faPowerOff} id="off" />
																	</button>
																}
															</div>
														</td>
													</tr>
													)
												})}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhum contrato encontrado com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		isEdicaoPermitida(contrato) {
			const user = this.props.user;
			return (user.isAdministrador === true && contrato.contratoSerpro === false) || (user.isMantenedor === true  && contrato.contratoSerpro === true) 
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const criterioPesquisa = this.state.criterioPesquisa;
			criterioPesquisa[nome] = valor;
			this.setState(prevState => ({ ...prevState, criterioPesquisa }));
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState(prevState => ({
				...prevState,
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}), () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada (pagina){

			const {criterioPesquisa} = this.state;
			criterioPesquisa['pagina'] = pagina;
			const url = '/api/contrato/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => { 
					this.setState(prevState => ({
						...prevState,
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}), () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os contratos. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			const user = this.props.user;
			let contratoSerpro = true;
			if(user.isAdministrador === true){
				contratoSerpro = false;
			}

			this.setState(prevState => ({
				...prevState,
				criterioPesquisa: {
					nomeContrato: '',
					nomeItemFaturavel: '',
					ativos : true,
					idTipoContrato: '',
					contratoSerpro,
				},
				resultadoPesquisa: {},
				pesquisaExecutada: false,
				exibeModalAtivar: false,
				exibeModalInativar: false,
				botoesHabilitados : true,
			}), () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}

		alterarSituacao (contrato){
			const body = { ativo: !contrato.ativo }
			this.setState(prevState => ({ ...prevState, botoesHabilitados: false }));
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			api.put(`/api/contrato/situacao/${contrato.id}`, body)
				.then(response => { 
					this.setState(prevState => ({
						...prevState,
						pesquisaExecutada : true,
					})) 
					this.pesquisar();
					let mensagem = contrato.ativo === true ? 'Contrato desabilitado com sucesso!' : 'Contrato habilitado com sucesso!';
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível alterar a situação do contrato.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState(prevState => ({ ...prevState, botoesHabilitados:true}));
				});
		}

		handleOkModais () {
			this.alterarSituacao(this.state.contratoAlvo);
			this.fechaModais();
		}

		confirmaOperacao(contrato) {
			this.setState(prevState => (
				{
					...prevState,
					exibeModalAtivar: contrato.ativo === false,
					exibeModalInativar: contrato.ativo === true,
					contratoAlvo: contrato,
				})
			);
		}

		fechaModais () {
			this.setState(prevState => (
				{
					...prevState,
					exibeModalAtivar:false,
					exibeModalInativar:false
				})
			);
		}
	}

) // redux
); // router